import { Star } from "lucide-react";

const testimonials = [
  {
    quote:
      "I was skeptical at first, but the product quality is incredible. I've already recommended it to all my friends and family.",
    author: "Sarah M.",
  },
  {
    quote:
      "The curated selection makes it so easy to find unique products. Every purchase has exceeded my expectations.",
    author: "James R.",
  },
  {
    quote:
      "Fast shipping and the items are exactly as described. This is my go-to shop for discovering new favorites.",
    author: "Emily K.",
  },
];

export function TestimonialsSection() {
  return (
    <section className="bg-bg-alt py-20">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <h2 className="mb-10 text-center text-[28px] font-medium tracking-tight text-heading">
          What Our Customers Say
        </h2>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="flex flex-col justify-between bg-white p-8"
            >
              <div>
                <div className="mb-4 flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <Star
                      key={j}
                      size={16}
                      className="fill-amber-400 text-amber-400"
                    />
                  ))}
                </div>
                <p className="text-[15px] leading-[1.7] text-text-muted">
                  "{t.quote}"
                </p>
              </div>
              <p className="mt-6 text-sm font-semibold text-heading">
                {t.author}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
